module.exports = __webpack_public_path__ + "static/media/pulsidTallaS.43f54991.webp";